import React, {useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AppBar, AppBarSection, AppBarSpacer, Avatar } from '@progress/kendo-react-layout';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import {LocalizationContext, UserContext} from '../../contexts';
import {languageWorkspaceOptions} from '../../config';
import './index.scss';

export default function Header(props) {
    const [localization, setLocalization] = useContext(LocalizationContext);
    const [user] = useContext(UserContext);
    const { pathname } = useLocation();
    const isRepositoryPage = pathname.startsWith('/repository') || pathname.startsWith('/newItem');

    var languagesList = languageWorkspaceOptions.map(option => {
      return {
        text: localization.labels[option.labelKey],
        id: option.id
      };
    });

    return (
        <div className="app-header" dir={localization.labels.dir}>
          <AppBar>
            <AppBarSection>
                <button className="k-button k-button-clear" onClick={props.onDrawerToggle}>
                    <span className="k-icon k-i-menu" />
                </button>
                <h3 className="app-title">{localization.labels.site_title}</h3>
                <span className="k-appbar-separator" />
                {user && <><Avatar shape="circle" type="image"><img src={user.userAvatarUrl} /></Avatar><span style={{margin: '0 8px'}}>{user.displayName}</span></>}
            </AppBarSection>
            <AppBarSpacer />
            {!isRepositoryPage && <AppBarSection>
              {localization.show_content_language && <DropDownList
                data={languagesList}
                value={languagesList.filter(lang => lang.id == localization.content_language)[0]}
                textField="text"
                dataItemKey="id"
                onChange={(event) => {
                  setLocalization({content_language: event.target.value.id});
                }}
              />}
            </AppBarSection>}
          </AppBar>
        </div>
    );
};